// exclude-from-index
import React, { PureComponent } from 'react';
import InputMask from 'react-input-mask';
import TextInput from '../TextInput';
import Country from '../../../constants/enums/Country';

class PhoneNumber extends PureComponent {
  render() {
    /**
     * We have to manually pass a few props directly to the wrapped TextInput component
     * This is due to how react-input-mask handles passthrough props on the child
     * render function.
     * See: https://github.com/sanniassin/react-input-mask#children--function
     */

    const { disabled, readOnly, country = '' } = this.props;
    const mask = country === Country.AU ? '+61 999999999' : '1 (999) 999-9999';

    return (
      /**
       * maskChar needs to be a space. Why? I don't know but there is an open issue on
       * GitHub acknowledging that setting maskChar to null or "" causes autofill to strip
       * the first character off the string being autofilled.
       * This fixes it.
       * See: https://github.com/sanniassin/react-input-mask/issues/161
       */
      <InputMask {...this.props} maskChar=" " mask={mask}>
        {inputProps => <TextInput {...inputProps} disabled={disabled} readOnly={readOnly} type="tel" />}
      </InputMask>
    );
  }
}

export default PhoneNumber;
